import { defineStore } from "pinia";
import Services from '@/services/newIdentificationCardServices'
import { mapNewIdentificationCard } from '@/helpers/mapFuncs'

export const useNewIdentificationCardStore = defineStore("newIdentificationCard", {

state:()=>({
    newIdentificationCard: {},
    newIdentificationCards: [],
}),
getters : {
    getNewIdentificationCard() {
        return mapNewIdentificationCard(this.newIdentificationCard)
    },
    getNewIdentificationCards() {
        return this.newIdentificationCards.map(mapNewIdentificationCard)
    }
},
actions : {
    /** Start Sets */
    setNewIdentificationCard(newIdentificationCard) {
        this.newIdentificationCard = newIdentificationCard
    },
    setNewIdentificationCards(newIdentificationCards) {
        this.newIdentificationCards = newIdentificationCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setNewIdentificationCard(response.data.data)
            return response
        })
    },
    getByPersonId(personId) {
        return Services.getByPersonId(personId)
        .then((response)=>{
            this.setNewIdentificationCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setNewIdentificationCards(response.data.data)
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.newIdentificationCards.push(response.data.data)
            return mapNewIdentificationCard(response.data.data)
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.newIdentificationCards[this.newIdentificationCards.findIndex((x)=>x.id == id)] = response.data.data
            return mapNewIdentificationCard(response.data.data)
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.newIdentificationCards = this.newIdentificationCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});